import {
    SET_PROJECT_STATE,
    SET_PROJECT_NAME,
    SET_PROJECT_STREET,
    SET_PROJECT_STREET_2,
    SET_PROJECT_ZIP,
    SET_PROJECT_CITY,
    SET_PROJECT_COUNTRY,
    SET_PROJECT_ADDRESS,
} from './constants';

const defaultState = {
    projectState: null,
    projectName: '',
    projectStreet: '',
    projectStreet2: '',
    projectZip: '',
    projectCity: '',
    projectCountry: 'USA',
};

const projectaddress = (state = defaultState, action) => {
    switch (action.type) {
        case SET_PROJECT_ADDRESS:
            return {
                ...state,
                projectStreet: action.address.address1,
                projectState: parseInt(action.address.state, 10),
                projectStreet2: action.address.address2,
                projectZip: action.address.zipCode,
                projectCity: action.address.city,
                projectCountry: action.address.country,
            };
        case SET_PROJECT_STATE:
            return { ...state, projectState: action.projectState };

        case SET_PROJECT_NAME:
            return { ...state, projectName: action.projectName };

        case SET_PROJECT_STREET:
            return { ...state, projectStreet: action.projectStreet };

        case SET_PROJECT_STREET_2:
            return { ...state, projectStreet2: action.projectStreet2 };

        case SET_PROJECT_ZIP:
            return { ...state, projectZip: action.projectZip };

        case SET_PROJECT_CITY:
            return { ...state, projectCity: action.projectCity };

        case SET_PROJECT_COUNTRY:
            return { ...state, projectCountry: action.projectCountry };
        default:
            return state;
    }
};

export default projectaddress;



// WEBPACK FOOTER //
// ./src/containers/common/projectaddress/reducer.js